export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  HTML: string;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
  Markdown: string;
  TZInfo: any;
  Upload: any;
}

/** Autogenerated input type of AcceptFamilyAccountInvitation */
export interface AcceptFamilyAccountInvitationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

/** Autogenerated input type of AddInsuranceByCarrierIdWithVerification */
export interface AddInsuranceByCarrierIdWithVerificationInput {
  carrierId?: InputMaybe<Scalars['String']>;
  carrierName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
}

/** Autogenerated input type of AddInsuranceWithVerification */
export interface AddInsuranceWithVerificationInput {
  cardImageS3KeyBack?: InputMaybe<Scalars['String']>;
  cardImageS3KeyFront?: InputMaybe<Scalars['String']>;
  carrierName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupNumber?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
}

export interface AddressAttributes {
  _destroy?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  crossStreet?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<AddressKind>;
  stateCode?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export enum AddressKind {
  Billing = 'billing',
  Home = 'home',
  Other = 'other',
  Work = 'work',
}

export enum AddressStatus {
  Current = 'CURRENT',
  Previous = 'PREVIOUS',
}

export enum AllowedResultsTypeNameEnum {
  Collection = 'collection',
  Integer = 'integer',
  Radio = 'radio',
  Text = 'text',
}

export enum AmazonPharmacyBrand {
  AmazonPharmacy = 'AmazonPharmacy',
  Other = 'Other',
}

/** various queryable relationships between patient and appointment */
export enum AppointmentQueryStrategy {
  ConnectedDevice = 'CONNECTED_DEVICE',
  /** For an appointment to be current, it must not have the state `no_show` or `cancelled`. The `end_at` must be in the future. It must _either_ have the `start_at` in the past _or_ be in the state `arrived` or `started`. */
  Current = 'CURRENT',
  /** Only includes appointments with state 'no show' or 'cancelled' */
  NotUtilized = 'NOT_UTILIZED',
  Past = 'PAST',
  /** appointments with a state of seen */
  Seen = 'SEEN',
  Upcoming = 'UPCOMING',
}

export interface AppointmentTypeInput {
  id?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated input type of AssignMembershipGroupSeat */
export interface AssignMembershipGroupSeatInput {
  claimCode: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lwaPurchaseRef?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of AssignPatientSurvey */
export interface AssignPatientSurveyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional due date for the survey. Defaults to current time if not provided. */
  dueOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Optional expiration date for the survey. Defaults to 3 months from now if not provided. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Optional flag to suppress action item notifications. If not provided, uses feature flag. */
  suppressNotifications?: InputMaybe<Scalars['Boolean']>;
  uniqueName: Scalars['String'];
}

/** Autogenerated input type of AttestSelfPayIsPrimaryInsurance */
export interface AttestSelfPayIsPrimaryInsuranceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum Attribute {
  /** Boolean value */
  Boolean = 'BOOLEAN',
  /** Integer value */
  Integer = 'INTEGER',
  /** ISO8601 datetime in format YYYY-MM-DDThh:mm */
  IsoDateTime = 'ISO_DATE_TIME',
  /** Number value */
  Number = 'NUMBER',
  /** String value */
  String = 'STRING',
}

/** Autogenerated input type of AuthorizeAmazonPharmacySharing */
export interface AuthorizeAmazonPharmacySharingInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of AutoEnrollMfa */
export interface AutoEnrollMfaInput {
  /** The preferred factor to use for MFA. Valid options are sms or voice */
  authFactor?: InputMaybe<MfaFactor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email to enroll in MFA as a backup factor */
  email?: InputMaybe<Scalars['String']>;
  /** Email address of pediatric user to have MFA enabled by an authorized parent */
  pediatricEmail?: InputMaybe<Scalars['String']>;
  /** Phone number to enroll in MFA. Format should be American 10-digit standard, following XXX-XXX-XXXX */
  phoneNumber: Scalars['String'];
}

export interface BiomarkerFilterInput {
  biomarkerId: Scalars['ID'];
  dateRange?: InputMaybe<DateRangeInput>;
}

export interface BloodPressureMeasurementInput {
  collectedAt: Scalars['DateTime'];
  diastolic: Scalars['Float'];
  systolic: Scalars['Float'];
}

export interface BookAppointmentAttributes {
  /** Optional free-form patient note providing supplementary context to the healthcare provider */
  additionalReasonForVisitContext?: InputMaybe<Scalars['String']>;
  appointmentTypeId: Scalars['ID'];
  /** Optional UMED Clinical Concept ID */
  clinicalConceptId?: InputMaybe<Scalars['ID']>;
  /** Whether the patient wants to be notified of earlier appointment availability */
  earlierAppointmentNotificationsOptIn?: InputMaybe<Scalars['Boolean']>;
  /** ID of the appointment inventory that will be booked as a part of rescheduling. */
  inventoryId: Scalars['ID'];
  /** Licensing Body short name used to assign office for remote primary care bookings */
  licensingBodyShortName?: InputMaybe<Scalars['String']>;
  /** Patient's reason for visit, either a structured reason for visit term selected during booking or a free-text input */
  reason?: InputMaybe<Scalars['String']>;
  /** Self-pay estimate range for the appointment */
  selfPayEstimate?: InputMaybe<Scalars['String']>;
  sendSms?: InputMaybe<Scalars['Boolean']>;
  /** Service Area ID used to assign office for remote Omni bookings */
  serviceAreaId?: InputMaybe<Scalars['ID']>;
  smsNumber?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of BookAppointment */
export interface BookAppointmentInput {
  appointmentAttributes: BookAppointmentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of CalculateInsights */
export interface CalculateInsightsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The enrollment date for the treatment plan */
  enrollmentDate: Scalars['ISO8601DateTime'];
  /** List of prescription IDs to filter medication insights */
  prescriptionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The type of treatment plan to calculate insights for */
  treatmentPlanType: Scalars['String'];
}

/** Autogenerated input type of CancelAppointment */
export interface CancelAppointmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

/** Autogenerated input type of CancelPrescriptionRenewalRequests */
export interface CancelPrescriptionRenewalRequestsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientMedicationIds: Array<Scalars['ID']>;
}

export enum CardVariant {
  Compact = 'COMPACT',
  Display = 'DISPLAY',
  Large = 'LARGE',
  Standard = 'STANDARD',
}

/** Status values for FHIR CarePlan resources */
export enum CarePlanStatusEnum {
  /** The care plan is active */
  Active = 'ACTIVE',
  /** The care plan has been completed */
  Completed = 'COMPLETED',
  /** The care plan is in draft status */
  Draft = 'DRAFT',
  /** The care plan was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The care plan is on hold */
  OnHold = 'ON_HOLD',
  /** The care plan has been revoked */
  Revoked = 'REVOKED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

export enum CareTeamType {
  /** PCP + mindset providers with domain specific labels (e.g. Therapist, Care Manager, Unknown) instead of default program enrollment label */
  BehavioralHealth = 'BEHAVIORAL_HEALTH',
  /** Everything in LONGITUDINAL plus appointments */
  Comprehensive = 'COMPREHENSIVE',
  /** PCP, then any program-based care */
  Longitudinal = 'LONGITUDINAL',
}

/** Scroll behavior types for carousel sections */
export enum CarouselScroll {
  /** Unrestricted scrolling, user has full control */
  Free = 'FREE',
  /** Cards snap to defined positions, ensuring each card is fully visible */
  Snap = 'SNAP',
}

/** Autogenerated input type of ChangePharmacyForPrescriptionRenewalRequests */
export interface ChangePharmacyForPrescriptionRenewalRequestsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientMedicationIds: Array<Scalars['ID']>;
  patientPharmacyId: Scalars['ID'];
}

export interface ChartClaimingPatientAttributes {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  legalFirstName?: InputMaybe<Scalars['String']>;
  legalLastName?: InputMaybe<Scalars['String']>;
}

export interface CheckEligibilityInput {
  program: ProgramEnum;
  step: ProgramStepEnum;
}

/** Autogenerated input type of ClaimChart */
export interface ClaimChartInput {
  accessKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  patientAttributes: ChartClaimingPatientAttributes;
  reCaptchaToken?: InputMaybe<Scalars['String']>;
}

/** Clinical status values for conditions and allergies */
export enum ClinicalStatusEnum {
  /** The condition/allergy is active */
  Active = 'ACTIVE',
  /** The condition/allergy is inactive */
  Inactive = 'INACTIVE',
  /** The condition/allergy has recurred */
  Recurrence = 'RECURRENCE',
  /** The condition/allergy has relapsed */
  Relapse = 'RELAPSE',
  /** The condition/allergy is in remission */
  Remission = 'REMISSION',
  /** The condition/allergy has been resolved */
  Resolved = 'RESOLVED',
}

/** Status values for FHIR Communication resources */
export enum CommunicationStatusEnum {
  /** The communication has been completed */
  Completed = 'COMPLETED',
  /** The communication was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The communication is in progress */
  InProgress = 'IN_PROGRESS',
  /** The communication was not done */
  NotDone = 'NOT_DONE',
  /** The communication is on hold */
  OnHold = 'ON_HOLD',
  /** The communication is being prepared */
  Preparation = 'PREPARATION',
  /** The communication has been stopped */
  Stopped = 'STOPPED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

/** Autogenerated input type of ConfirmAppointment */
export interface ConfirmAppointmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

export enum ContentBlockMetadataStyles {
  Dark = 'Dark',
  ErrorLight = 'ErrorLight',
  InfoLight = 'InfoLight',
  Light = 'Light',
  SuccessLight = 'SuccessLight',
  WarningLight = 'WarningLight',
}

/** Autogenerated input type of CreateCustomPharmacy */
export interface CreateCustomPharmacyInput {
  addressAttributes: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Applies to mail order pharmacies only. Not required, even for mail order pharmacies. */
  customerCode?: InputMaybe<Scalars['String']>;
  isMailOrder?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phoneNumbersAttributes: PhoneNumberAttributes;
}

/** Autogenerated input type of CreateFamilyAccountInvitation */
export interface CreateFamilyAccountInvitationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
}

/** Autogenerated input type of CreateHealthInformationReleaseAuthorization */
export interface CreateHealthInformationReleaseAuthorizationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  documentVersion: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  recipientTelephone: Scalars['String'];
  signatureText: Scalars['String'];
  signedAt: Scalars['DateTime'];
}

/** Autogenerated input type of CreateHealthKitMeasurements */
export interface CreateHealthKitMeasurementsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  measurementType?: InputMaybe<Scalars['String']>;
  measurements: Array<HealthKitDeviceMeasurementInputObject>;
}

/** Autogenerated input type of CreateMedicationAdministration */
export interface CreateMedicationAdministrationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** @deprecated Use prescription_id instead */
  patientMedicationRegimenId?: InputMaybe<Scalars['ID']>;
  performerId?: InputMaybe<Scalars['ID']>;
  performerIdType?: InputMaybe<MedicationAdministrationPerformerTypeEnum>;
  prescriptionId?: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
  status: MedicationAdministrationStatusEnum;
}

/** Autogenerated input type of CreatePatientMeasurement */
export interface CreatePatientMeasurementInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** @deprecated Use 'measurement' argument instead */
  collectedAt?: InputMaybe<Scalars['DateTime']>;
  measurement?: InputMaybe<MeasurementsInput>;
  /** @deprecated Use 'measurement' argument instead */
  type?: InputMaybe<MeasurementName>;
  /** @deprecated Use 'measurement' argument instead */
  value?: InputMaybe<Scalars['Float']>;
}

/** Autogenerated input type of CreatePatientPharmacy */
export interface CreatePatientPharmacyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Applies to mail-order pharmacies only. Not required, even for mail order pharmacies. */
  customerCode?: InputMaybe<Scalars['ID']>;
  pharmacyId: Scalars['ID'];
}

/** Autogenerated input type of CreatePatientReportedSideEffect */
export interface CreatePatientReportedSideEffectInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['ID']>;
  recordedDate?: InputMaybe<Scalars['DateTime']>;
  recorderId?: InputMaybe<Scalars['ID']>;
  recorderIdType?: InputMaybe<Scalars['String']>;
  resultingEffects: Array<ResultingEffectInput>;
}

/** Autogenerated input type of CreatePatientSurvey */
export interface CreatePatientSurveyInput {
  answers: Array<PatientSurveyAnswer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmed: Scalars['Boolean'];
  /** Deprecated, do not use. To be removed. */
  surveyId?: InputMaybe<Scalars['ID']>;
  surveySystemName?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated input type of CreatePediatricMembershipGroupInvite */
export interface CreatePediatricMembershipGroupInviteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface CreatePrescriptionRenewalRequestAttributes {
  comment?: InputMaybe<Scalars['String']>;
  patientMedicationId: Scalars['ID'];
}

/** Autogenerated input type of CreatePrescriptionRenewalRequests */
export interface CreatePrescriptionRenewalRequestsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  createPrescriptionRenewalRequestAttributes: Array<CreatePrescriptionRenewalRequestAttributes>;
  patientPharmacyId: Scalars['ID'];
}

/** Autogenerated input type of CreateStripeSetupIntentForPatient */
export interface CreateStripeSetupIntentForPatientInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of CreateToken */
export interface CreateTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
}

export interface DateRangeInput {
  endDate: Scalars['ISO8601DateTime'];
  startDate: Scalars['ISO8601DateTime'];
}

/** Autogenerated input type of DeclineFamilyAccountInvitation */
export interface DeclineFamilyAccountInvitationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

export interface DeleteLabRecordInput {
  s3Uri: Scalars['String'];
}

/** Autogenerated input type of DeleteTimelineCommentDraft */
export interface DeleteTimelineCommentDraftInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Patient Timeline Comment ID */
  id: Scalars['ID'];
}

/** Autogenerated input type of DeleteTimelinePostDraft */
export interface DeleteTimelinePostDraftInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Patient Timeline Post ID */
  id: Scalars['ID'];
}

/** Autogenerated input type of DemographicsToken */
export interface DemographicsTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of DemographicsTokenWithVerification */
export interface DemographicsTokenWithVerificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of DetachStripePaymentMethodForPatient */
export interface DetachStripePaymentMethodForPatientInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
}

/** Status values for FHIR DiagnosticReport resources */
export enum DiagnosticReportStatusEnum {
  /** The report has been amended */
  Amended = 'AMENDED',
  /** The report has been appended */
  Appended = 'APPENDED',
  /** The report has been cancelled */
  Cancelled = 'CANCELLED',
  /** The report has been corrected */
  Corrected = 'CORRECTED',
  /** The report was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The report is final */
  Final = 'FINAL',
  /** The report is partial */
  Partial = 'PARTIAL',
  /** The report is preliminary */
  Preliminary = 'PRELIMINARY',
  /** The report is registered */
  Registered = 'REGISTERED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

/** Enum for Home Screen dialog types */
export enum DialogType {
  ModifyVisit = 'modifyVisit',
  MoreOptions = 'moreOptions',
}

/** Autogenerated input type of DisableAccountSwitching */
export interface DisableAccountSwitchingInput {
  accessRelationshipId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of DismissAlert */
export interface DismissAlertInput {
  alertKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of DismissWebDownloadMobileAppHero */
export interface DismissWebDownloadMobileAppHeroInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum ElectronicHealthInformationExportFormat {
  Pdf = 'PDF',
  Zip = 'ZIP',
}

export enum ElectronicHealthInformationExportState {
  Available = 'available',
  Failed = 'failed',
  InProgress = 'in_progress',
  Requested = 'requested',
  Retrying = 'retrying',
}

export enum EmailKind {
  B2bEmployeeWork = 'b2b_employee_work',
  DirectMessage = 'direct_message',
  Other = 'other',
  Personal = 'personal',
  Shared = 'shared',
  Work = 'work',
}

export enum EmailVerificationStatus {
  LockedOut = 'locked_out',
  Unverified = 'unverified',
  Verified = 'verified',
}

export interface EmergencyContactInputObject {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  addressAttributes?: InputMaybe<PatientAddressInputObject>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumberAttributes?: InputMaybe<PatientPhoneNumberInputObject>;
  relationship?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of EnableAccountSwitching */
export interface EnableAccountSwitchingInput {
  accessRelationshipId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Encounter class values */
export enum EncounterClassEnum {
  /** Ambulatory encounter */
  Ambulatory = 'AMBULATORY',
  /** Emergency encounter */
  Emergency = 'EMERGENCY',
  /** Field encounter */
  Field = 'FIELD',
  /** Home health encounter */
  HomeHealth = 'HOME_HEALTH',
  /** Inpatient encounter */
  Inpatient = 'INPATIENT',
  /** Inpatient acute encounter */
  InpatientAcute = 'INPATIENT_ACUTE',
  /** Inpatient non-acute encounter */
  InpatientNonAcute = 'INPATIENT_NON_ACUTE',
  /** Observation encounter */
  Observation = 'OBSERVATION',
  /** Pre-admission encounter */
  PreAdmission = 'PRE_ADMISSION',
  /** Short stay encounter */
  ShortStay = 'SHORT_STAY',
  /** Virtual encounter */
  Virtual = 'VIRTUAL',
}

/** Status values for FHIR Encounter resources */
export enum EncounterStatusEnum {
  /** The patient has arrived */
  Arrived = 'ARRIVED',
  /** The encounter has been cancelled */
  Cancelled = 'CANCELLED',
  /** The encounter was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The encounter is finished */
  Finished = 'FINISHED',
  /** The encounter is in progress */
  InProgress = 'IN_PROGRESS',
  /** The encounter is on hold */
  OnHold = 'ON_HOLD',
  /** The Encounter has begun, but the patient is temporarily on leave */
  OnLeave = 'ON_LEAVE',
  /** The encounter is planned */
  Planned = 'PLANNED',
  /** The patient has been triaged */
  Triaged = 'TRIAGED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

export interface EnrollUserInput {
  program: ProgramEnum;
}

export enum ErrorTypes {
  NonRecoverable = 'NON_RECOVERABLE',
  RetryableImmediate = 'RETRYABLE_IMMEDIATE',
}

export enum EventCategory {
  Alert = 'ALERT',
  Navigation = 'NAVIGATION',
}

/** Autogenerated input type of ExpireBookingSession */
export interface ExpireBookingSessionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of ExpireUserNotification */
export interface ExpireUserNotificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

export enum FlagVariant {
  Off = 'Off',
  OnAlternateText = 'OnAlternateText',
  OnControlText = 'OnControlText',
}

/** Autogenerated input type of ForgetAmazonPharmacyEnrollment */
export interface ForgetAmazonPharmacyEnrollmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum FreeTextQuestionId {
  UserFreetextFeedback = 'USER_FREETEXT_FEEDBACK',
}

export interface FreetextResponseInput {
  /** Must be "USER_FREETEXT_FEEDBACK" */
  questionId: FreeTextQuestionId;
  /** The text of the question */
  questionText: Scalars['String'];
  /** Typed response from the user for this question */
  response: Scalars['String'];
}

/** Autogenerated input type of GenerateElectronicHealthInformationExport */
export interface GenerateElectronicHealthInformationExportInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  format: ElectronicHealthInformationExportFormat;
}

export interface GeneratedResponsePayloadInput {
  content?: InputMaybe<Scalars['String']>;
  requiresGeneratedInput: Scalars['Boolean'];
  type: Scalars['String'];
}

/** Strongly-typed lat/long input. */
export interface Geolocation {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}

export interface GetBiomarkerAnalysisInput {
  requestId: Scalars['String'];
}

export interface GetLabRecordsInput {
  requestId: Scalars['String'];
}

export interface GetQuestionnaireResponsesInput {
  questionnaireId: Scalars['String'];
}

export interface GetUserBiomarkerDetailsInput {
  biomarkers?: InputMaybe<Array<BiomarkerFilterInput>>;
  patientId?: InputMaybe<Scalars['ID']>;
  requestId: Scalars['String'];
}

/** Pathway goal type values */
export enum GoalTypeEnum {
  WeightTarget = 'WEIGHT_TARGET',
}

/** Autogenerated input type of GrantConnectedDevicePatientAuthorization */
export interface GrantConnectedDevicePatientAuthorizationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Names of health goal result types */
export enum HealthGoalResultTypeNameEnum {
  BooleanHealthGoalResultType = 'BooleanHealthGoalResultType',
  CategoricalHealthGoalResultType = 'CategoricalHealthGoalResultType',
  NumericalHealthGoalResultType = 'NumericalHealthGoalResultType',
  UnstructuredHealthGoalResultType = 'UnstructuredHealthGoalResultType',
}

export interface HealthKitDeviceAttributes {
  manufacturer?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  udiCarrierAttributes?: InputMaybe<Array<UdiCarrierAttributes>>;
  userFriendlyName?: InputMaybe<Scalars['String']>;
}

export interface HealthKitDeviceMeasurementInputObject {
  /** Format should be ISO 8601 */
  collectedAt?: InputMaybe<Scalars['DateTime']>;
  deviceAttributes?: InputMaybe<HealthKitDeviceAttributes>;
  name: MeasurementName;
  sourceAttributes?: InputMaybe<HealthKitSourceAttributes>;
  uuid: Scalars['String'];
  value: Scalars['String'];
}

export interface HealthKitSourceAttributes {
  bundleIdentifier?: InputMaybe<Scalars['String']>;
  /** The name of the device or healthkit linked app the data is coming from */
  name?: InputMaybe<Scalars['String']>;
  /** The operating system version of the device sending the data */
  operatingSystemVersion?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  /** The version of the app or device sending the data */
  version?: InputMaybe<Scalars['String']>;
}

export enum ImageSourceLocation {
  Local = 'LOCAL',
  Url = 'URL',
}

/** Status values for FHIR Immunization resources */
export enum ImmunizationStatusEnum {
  /** The immunization has been completed */
  Completed = 'COMPLETED',
  /** The immunization was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The immunization was not done */
  NotDone = 'NOT_DONE',
}

export enum IneligibilityReasonTypeEnum {
  /** Expired requirement */
  Expired = 'EXPIRED',
  /** Incomplete requirement */
  Incomplete = 'INCOMPLETE',
  /** Missing requirement */
  Missing = 'MISSING',
}

export enum InferredBiomarkerTypeEnum {
  /** Focus area type */
  FocusArea = 'FOCUS_AREA',
  /** Score type */
  Score = 'SCORE',
}

/** Insight severity levels */
export enum InsightSeverityEnum {
  Info = 'INFO',
  Warning = 'WARNING',
}

/** Pathways insight type values */
export enum InsightTypeEnum {
  Medication = 'MEDICATION',
  SideEffects = 'SIDE_EFFECTS',
  WeightLossProgress = 'WEIGHT_LOSS_PROGRESS',
}

export interface InternalUserDisplayNameOptions {
  lastInitial?: InputMaybe<Scalars['Boolean']>;
  showSuffix?: InputMaybe<Scalars['Boolean']>;
}

export enum LabRecordSourceEnum {
  /** One Medical */
  Om = 'OM',
  /** User uploaded */
  User = 'USER',
}

/** Autogenerated input type of LinkAmazonAccount */
export interface LinkAmazonAccountInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum LinkingInitiatedEvent {
  LinkingInitiated = 'linking_initiated',
  LinkingInitiatedWithDataSharing = 'linking_initiated_with_data_sharing',
}

/** Autogenerated input type of LinkingInitiated */
export interface LinkingInitiatedInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventType: LinkingInitiatedEvent;
}

export enum ManualHieQueryAvailability {
  /** able to invoke a manual hie query */
  Eligible = 'ELIGIBLE',
  /** patient has not consented to manual hie queries */
  NotEligible = 'NOT_ELIGIBLE',
  /** manual hie query invoked too recently */
  NotReady = 'NOT_READY',
}

export enum ManualHieQueryStatus {
  /** transaction not found */
  DoesNotExist = 'DOES_NOT_EXIST',
  /** transaction failed during execution */
  Failed = 'FAILED',
  /** transaction is ongoing */
  InProgress = 'IN_PROGRESS',
  /** transaction completed successfully */
  Succeeded = 'SUCCEEDED',
}

/** Autogenerated input type of MarkAllUserNotificationsAsRead */
export interface MarkAllUserNotificationsAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** For the given Patient::Timeline::Post#id, marks all notifications for that post and its comments as read. If omitted, all notifications for the user are marked as read. */
  postId?: InputMaybe<Scalars['ID']>;
}

/** Autogenerated input type of MarkAsLateToAppointment */
export interface MarkAsLateToAppointmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}

/** Autogenerated input type of MarkRegComplete */
export interface MarkRegCompleteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum MeasurementName {
  DiastolicPressure = 'diastolicPressure',
  HeartRate = 'heartRate',
  Spo2 = 'spo2',
  SystolicPressure = 'systolicPressure',
  Temperature = 'temperature',
  Weight = 'weight',
}

/** Input for creating a measurement. Provide exactly one of: simple_measurement or blood_pressure */
export interface MeasurementsInput {
  bloodPressure?: InputMaybe<BloodPressureMeasurementInput>;
  simpleMeasurement?: InputMaybe<SingleValuedMeasurementInput>;
}

export interface MedicationAdministrationFilterInput {
  patientMedicationRegimenId?: InputMaybe<Scalars['ID']>;
  performerId?: InputMaybe<Scalars['ID']>;
  performerIdType?: InputMaybe<MedicationAdministrationPerformerTypeEnum>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<MedicationAdministrationStatusEnum>;
}

/** The type of performer for medication administration */
export enum MedicationAdministrationPerformerTypeEnum {
  /** Internal user performed the administration */
  InternalUser = 'INTERNAL_USER',
  /** Patient performed the administration */
  Patient = 'PATIENT',
}

export enum MedicationAdministrationSortEnum {
  /** Sort by created at ascending */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by created at descending */
  CreatedAtDesc = 'CREATED_AT_DESC',
  /** Sort by start time ascending */
  StartTimeAsc = 'START_TIME_ASC',
  /** Sort by start time descending */
  StartTimeDesc = 'START_TIME_DESC',
}

/** The status of medication administration */
export enum MedicationAdministrationStatusEnum {
  /** Administration was completed */
  Completed = 'COMPLETED',
  /** Administration was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** Administration is in progress */
  InProgress = 'IN_PROGRESS',
  /** Administration was not done */
  NotDone = 'NOT_DONE',
  /** Administration is on hold */
  OnHold = 'ON_HOLD',
  /** Administration was stopped */
  Stopped = 'STOPPED',
  /** Administration status is unknown */
  Unknown = 'UNKNOWN',
}

/** Status values for FHIR MedicationDispense resources */
export enum MedicationDispenseStatusEnum {
  /** The dispense has been cancelled */
  Cancelled = 'CANCELLED',
  /** The dispense has been completed */
  Completed = 'COMPLETED',
  /** The dispense was declined */
  Declined = 'DECLINED',
  /** The dispense was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The dispense is in progress */
  InProgress = 'IN_PROGRESS',
  /** The dispense is on hold */
  OnHold = 'ON_HOLD',
  /** The dispense is being prepared */
  Preparation = 'PREPARATION',
  /** The dispense has been stopped */
  Stopped = 'STOPPED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

/** Status values for FHIR MedicationRequest resources */
export enum MedicationRequestStatusEnum {
  /** The prescription is active */
  Active = 'ACTIVE',
  /** The prescription has been cancelled */
  Cancelled = 'CANCELLED',
  /** The prescription has been completed */
  Completed = 'COMPLETED',
  /** The prescription is in draft status */
  Draft = 'DRAFT',
  /** The prescription was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The prescription is on hold */
  OnHold = 'ON_HOLD',
  /** The prescription has been stopped */
  Stopped = 'STOPPED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

export enum MembershipGroupInviteStatus {
  Claimed = 'claimed',
  Created = 'created',
  FailedToSend = 'failed_to_send',
  InProgress = 'in_progress',
  Rejected = 'rejected',
  Revoked = 'revoked',
  Sent = 'sent',
}

export enum MembershipGroupSeatStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Open = 'open',
  Pending = 'pending',
}

export enum MembershipGroupSeatStoppedBy {
  External = 'external',
  OmMember = 'om_member',
}

export enum MfaFactor {
  Sms = 'sms',
  Voice = 'voice',
}

export interface MultipleChoiceAnswerOptionInput {
  /** The text shown to the user */
  answerText: Scalars['String'];
  /** Flag indicating whether or not there will be a follow-up question */
  isTerminalAnswer: Scalars['Boolean'];
  /** UUID to identify the answer option */
  nodeId: Scalars['ID'];
}

export interface MultipleChoicePayloadInput {
  /** An array of triage question objects */
  content?: InputMaybe<Array<MultipleChoiceQuestionInput>>;
  /** Set to true as returned by toucanNewConversation or toucanContinueConversation */
  requiresMultipleChoiceSelectionInput: Scalars['Boolean'];
  /** An array containing question and answer option IDs previously answered by the user in the current triage question series */
  selectedAnswers: Array<SelectedAnswerInput>;
  /** must be "multipleChoice". */
  type: Scalars['String'];
}

export enum MultipleChoiceQuestionConstraint {
  MultipleSelection = 'MULTIPLE_SELECTION',
  SingleSelection = 'SINGLE_SELECTION',
}

export interface MultipleChoiceQuestionInput {
  /** Answer options for the question */
  answerOptions: Array<MultipleChoiceAnswerOptionInput>;
  /** Either 'singleSelection' or 'multipleSelection' */
  constraint: MultipleChoiceQuestionConstraint;
  /** UUID to identify the question */
  nodeId: Scalars['ID'];
  /**
   * DEPRECATED: Use answer_options instead
   * @deprecated Use answer_options instead
   */
  optionsList?: InputMaybe<Array<Scalars['String']>>;
  /**
   * DEPRECATED: Use question_text instead
   * @deprecated Use question_text instead
   */
  question?: InputMaybe<Scalars['String']>;
  /** The text shown to the user */
  questionText: Scalars['String'];
  /** Type of the multiple choice question */
  questionType: Scalars['String'];
  /**
   * DEPRECATED: Use selectedAnswers at the payload level instead
   * @deprecated Use selectedAnswers at the payload level instead
   */
  selectionIndices?: InputMaybe<Array<Scalars['Int']>>;
}

export interface MultipleChoiceResponseInput {
  /** Unique ID assigned to each feedback question (client-defined) */
  questionId: Scalars['String'];
  /** The text of the question */
  questionText: Scalars['String'];
  /** A list of options selected by the user */
  response: Array<Scalars['String']>;
}

export enum Navigation {
  Modal = 'MODAL',
  Pop = 'POP',
  Push = 'PUSH',
  Sheet = 'SHEET',
}

/** Status values for FHIR Observation resources */
export enum ObservationStatusEnum {
  /** The observation has been amended */
  Amended = 'AMENDED',
  /** The observation has been cancelled */
  Cancelled = 'CANCELLED',
  /** The observation has been corrected */
  Corrected = 'CORRECTED',
  /** The observation was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The observation is final */
  Final = 'FINAL',
  /** The observation is preliminary */
  Preliminary = 'PRELIMINARY',
  /** The observation is registered */
  Registered = 'REGISTERED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

export enum OnboardingTaskName {
  HealthInformationExchangePage = 'health_information_exchange_page',
  WelcomeModal = 'welcome_modal',
}

export enum OnboardingTaskStatus {
  Complete = 'complete',
  Incomplete = 'incomplete',
}

export enum OpmEligibilityStatus {
  Active = 'active',
  Error = 'error',
  Inactive = 'inactive',
  Pending = 'pending',
  SelfPay = 'self_pay',
}

export interface ParticipantConsentInput {
  consentStatus: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

/** Pathway types */
export enum PathwayTypeEnum {
  BehavioralHealth = 'BEHAVIORAL_HEALTH',
  WeightLoss = 'WEIGHT_LOSS',
}

export interface PatientAddressInputObject {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

/** Input parameters for patient appointment inventory search */
export interface PatientAppointmentInventorySearchInput {
  /** ID of the appointment type to search for (required unless topic_name is provided) */
  appointmentTypeId?: InputMaybe<Scalars['ID']>;
  /** Search end date in YYYY-MM-DD format */
  dateEnd?: InputMaybe<Scalars['String']>;
  /** Search start date in YYYY-MM-DD format (defaults to today if not provided) */
  dateStart?: InputMaybe<Scalars['String']>;
  /** Group appointment inventories by date */
  groupByDate?: InputMaybe<Scalars['Boolean']>;
  /** Array of office IDs to limit search to */
  officeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit search to onsite appointments only */
  onsiteOnly?: InputMaybe<Scalars['Boolean']>;
  /** Single provider ID to search for */
  providerId?: InputMaybe<Scalars['ID']>;
  /** Array of provider IDs for Remote Primary Care searches. Requires RPC access. */
  providerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Maximum number of providers to return (pagination) */
  providerLimit?: InputMaybe<Scalars['Int']>;
  /** Pagination offset for provider results */
  providerOffset?: InputMaybe<Scalars['Int']>;
  /** Include remote appointment alternatives in results */
  recommendRemoteResults?: InputMaybe<Scalars['Boolean']>;
  /** Service area ID to search within */
  serviceAreaId?: InputMaybe<Scalars['ID']>;
  /** State licensing body code for Remote Primary Care provider filtering (e.g., 'CA', 'NY'). Filters to providers licensed in the specified state. Requires RPC access. */
  stateCode?: InputMaybe<Scalars['String']>;
  /** Care topic name (alternative to appointment_type_id) */
  topicName?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of PatientDisableMfa */
export interface PatientDisableMfaInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface PatientDisplayNameOptions {
  /** Makes the last name appear first (Lastnamerson, Firsty) */
  lastFirst?: InputMaybe<Scalars['Boolean']>;
  middleName?: InputMaybe<Scalars['Boolean']>;
  preferredName?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['Boolean']>;
}

export enum PatientMedicationStatusEnum {
  Active = 'active',
  Deleted = 'deleted',
  Discontinued = 'discontinued',
  Pending = 'pending',
}

export interface PatientPhoneNumberInputObject {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<PatientPhoneNumberKind>;
  number?: InputMaybe<Scalars['String']>;
}

export enum PatientPhoneNumberKind {
  Home = 'home',
  Mobile = 'mobile',
  Other = 'other',
  Work = 'work',
}

/** Autogenerated input type of PatientRegenerateMfaRecoveryCode */
export interface PatientRegenerateMfaRecoveryCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface PatientSurveyAnswer {
  answerId?: InputMaybe<Scalars['ID']>;
  answerText?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<SurveyAnswerKind>;
  surveyQuestionId?: InputMaybe<Scalars['ID']>;
}

/** Enum for PatientTaskType order types */
export enum PatientTaskOrderType {
  BasicFollowUpOrder = 'BasicFollowUpOrder',
  ConnectedDeviceOrder = 'ConnectedDeviceOrder',
  ConsultOrder = 'ConsultOrder',
  GenericFollowUpOrder = 'GenericFollowUpOrder',
  LabOrder = 'LabOrder',
  ProcedureOrder = 'ProcedureOrder',
  SurveyOrder = 'SurveyOrder',
  VaccineOrder = 'VaccineOrder',
  VisitFollowUpOrder = 'VisitFollowUpOrder',
}

export enum PatientTaskSort {
  /** Sorts patient tasks by updated_at date in descending order. */
  UpdatedAtDesc = 'UpdatedAtDesc',
}

/** Enum for PatientTaskType states */
export enum PatientTaskState {
  Assigned = 'assigned',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Declined = 'declined',
  Expired = 'expired',
}

export enum PharmacyMedicationAvailabilityStatusEnum {
  Available = 'available',
  CurrentlyUnavailable = 'currently_unavailable',
  DoesNotFill = 'does_not_fill',
  Unavailable = 'unavailable',
  Unknown = 'unknown',
}

export enum PharmacyMedicationDeliveryPromiseConfidenceEnum {
  High = 'high',
  Low = 'low',
}

export enum PharmacyMedicationDeliveryPromiseStyleEnum {
  Banner = 'BANNER',
  PharmacySearch = 'PHARMACY_SEARCH',
}

export interface PhoneNumberAttributes {
  _destroy?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<PhoneNumberKind>;
  number?: InputMaybe<Scalars['String']>;
}

export enum PhoneNumberKind {
  BackOffice = 'back_office',
  Fax = 'fax',
  Home = 'home',
  Mobile = 'mobile',
  Other = 'other',
  Pager = 'pager',
  PatientAssistance = 'patient_assistance',
  Work = 'work',
}

/** Enum for Home Screen popup modal types */
export enum PopupModalType {
  VisitModalityOnboarding = 'VISIT_MODALITY_ONBOARDING',
}

/** Autogenerated input type of PostAmazonPharmacyEnrollment */
export interface PostAmazonPharmacyEnrollmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
}

export enum ProblemStatus {
  Current = 'current',
  Mistaken = 'mistaken',
  Rejected = 'rejected',
  Resolved = 'resolved',
  Suspected = 'suspected',
  Unconfirmed = 'unconfirmed',
}

/** Status values for FHIR Procedure resources */
export enum ProcedureStatusEnum {
  /** The procedure has been completed */
  Completed = 'COMPLETED',
  /** The procedure was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The procedure is in progress */
  InProgress = 'IN_PROGRESS',
  /** The procedure was not done */
  NotDone = 'NOT_DONE',
  /** The procedure is on hold */
  OnHold = 'ON_HOLD',
  /** The procedure is being prepared */
  Preparation = 'PREPARATION',
  /** The procedure has been stopped */
  Stopped = 'STOPPED',
  /** The status is unknown */
  Unknown = 'UNKNOWN',
}

export interface ProfileInfo {
  addressesAttributes?: InputMaybe<Array<PatientAddressInputObject>>;
  emergencyContactsAttributes?: InputMaybe<Array<EmergencyContactInputObject>>;
  employerName?: InputMaybe<Scalars['String']>;
  employerZipCode?: InputMaybe<Scalars['String']>;
  genderDetails?: InputMaybe<Scalars['String']>;
  insurancesManuallyVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  phoneNumbersAttributes?: InputMaybe<Array<PatientPhoneNumberInputObject>>;
  preferredName?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<Scalars['Upload']>;
  pronounGroup?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
}

export enum ProgramEnum {
  /** Biomarker analysis Program */
  BiomarkerAnalysis = 'BIOMARKER_ANALYSIS',
}

export enum ProgramStepEnum {
  /** Ingress step */
  Ingress = 'INGRESS',
  /** Onboarding step */
  Onboarding = 'ONBOARDING',
  /** Processing step */
  Processing = 'PROCESSING',
}

export enum ProgramSystemName {
  HighRiskCareManagement = 'HIGH_RISK_CARE_MANAGEMENT',
  MindsetPlus = 'MINDSET_PLUS',
}

export enum ProviderSortBy {
  LastName = 'LAST_NAME',
}

export enum RecordRequest {
  AuthorizeFamily = 'AUTHORIZE_FAMILY',
  ObtainRecords = 'OBTAIN_RECORDS',
  ReleaseRecords = 'RELEASE_RECORDS',
}

/** Autogenerated input type of RefuseAmazonPharmacySharing */
export interface RefuseAmazonPharmacySharingInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum RegistrationWaitlistEnrollmentState {
  Registered = 'registered',
  Waitlisted = 'waitlisted',
}

/** Autogenerated input type of RemoveSelfFromMembershipGroupSubscription */
export interface RemoveSelfFromMembershipGroupSubscriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of ReportAmazonPharmacyEnrollment */
export interface ReportAmazonPharmacyEnrollmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Intent values for medication requests and care plans */
export enum RequestIntentEnum {
  /** A filler order */
  FillerOrder = 'FILLER_ORDER',
  /** An instance order */
  InstanceOrder = 'INSTANCE_ORDER',
  /** An option */
  Option = 'OPTION',
  /** A request/demand for something to occur */
  Order = 'ORDER',
  /** An original order */
  OriginalOrder = 'ORIGINAL_ORDER',
  /** An intention to ensure something occurs */
  Plan = 'PLAN',
  /** A suggestion made by someone/something */
  Proposal = 'PROPOSAL',
  /** A reflex order */
  ReflexOrder = 'REFLEX_ORDER',
}

/** Autogenerated input type of RequestMedicalRecords */
export interface RequestMedicalRecordsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export interface RescheduleAppointmentAttributes {
  appointmentTypeId: Scalars['ID'];
  /** ID of the appointment inventory that will be booked as a part of rescheduling. */
  inventoryId: Scalars['ID'];
  /** Licensing Body short name used to assign office for remote primary care bookings */
  licensingBodyShortName?: InputMaybe<Scalars['String']>;
  /** Self-pay estimate range for the appointment */
  selfPayEstimate?: InputMaybe<Scalars['String']>;
  sendSms?: InputMaybe<Scalars['Boolean']>;
  /** Service Area ID used to assign office for remote Omni bookings */
  serviceAreaId?: InputMaybe<Scalars['ID']>;
  smsNumber?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of RescheduleAppointment */
export interface RescheduleAppointmentInput {
  appointmentCancellationReasonId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the appointment that will be cancelled as a part of rescheduling. */
  fromAppointmentId: Scalars['ID'];
  newAppointmentAttributes: RescheduleAppointmentAttributes;
}

/** Autogenerated input type of ResendDirectSignupEmail */
export interface ResendDirectSignupEmailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
}

export interface ResponseEntityInput {
  /** A list of attributes which convey the necessary information about this entity */
  attributes?: InputMaybe<Array<ToolAttributeInput>>;
  /** A unique identifier for this specific entity */
  id?: InputMaybe<Scalars['ID']>;
  /** A string which describes the 'type' of entity. For example: 'Doctor' */
  type?: InputMaybe<Scalars['String']>;
}

export interface ResultingEffectInput {
  conditionId?: InputMaybe<Scalars['ID']>;
  severity: Scalars['String'];
}

/** Autogenerated input type of RevokeAbandonedMembershipGroupInvites */
export interface RevokeAbandonedMembershipGroupInvitesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of RevokeConnectedDevicePatientAuthorization */
export interface RevokeConnectedDevicePatientAuthorizationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of RevokeMembershipGroupInvite */
export interface RevokeMembershipGroupInviteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['ID'];
}

export enum RoleEnum {
  A2HRegisteredNurseMphp = 'A2H_REGISTERED_NURSE_MPHP',
  A2HTccMphp = 'A2H_TCC_MPHP',
  AcoProvider = 'ACO_PROVIDER',
  Acupuncturist = 'ACUPUNCTURIST',
  Admin = 'ADMIN',
  AdvancedSeniorHealthReferrals = 'ADVANCED_SENIOR_HEALTH_REFERRALS',
  Allergist = 'ALLERGIST',
  AutomatedTemplateEditor = 'AUTOMATED_TEMPLATE_EDITOR',
  AutoReplyTemplateManager = 'AUTO_REPLY_TEMPLATE_MANAGER',
  BillingAdmin = 'BILLING_ADMIN',
  BirdseyeReview = 'BIRDSEYE_REVIEW',
  CalendarAdmin = 'CALENDAR_ADMIN',
  Cardiologist = 'CARDIOLOGIST',
  CareManager = 'CARE_MANAGER',
  CareNav = 'CARE_NAV',
  CareTeam = 'CARE_TEAM',
  CareTeamPatientRecovery = 'CARE_TEAM_PATIENT_RECOVERY',
  CentralizedAdmin = 'CENTRALIZED_ADMIN',
  CentralBillingSpecialist = 'CENTRAL_BILLING_SPECIALIST',
  CentralSupportSpecialistOne = 'CENTRAL_SUPPORT_SPECIALIST_ONE',
  CentralSupportSpecialistThree = 'CENTRAL_SUPPORT_SPECIALIST_THREE',
  CentralSupportSpecialistTwo = 'CENTRAL_SUPPORT_SPECIALIST_TWO',
  CeClinicalTrialTeam = 'CE_CLINICAL_TRIAL_TEAM',
  ChargeCaptureAndCodingSpecialists = 'CHARGE_CAPTURE_AND_CODING_SPECIALISTS',
  ChartPrepReview = 'CHART_PREP_REVIEW',
  Chiropractic = 'CHIROPRACTIC',
  ChronicCareProvider = 'CHRONIC_CARE_PROVIDER',
  ClientServices = 'CLIENT_SERVICES',
  ClinicalDocumentIntegrityReview = 'CLINICAL_DOCUMENT_INTEGRITY_REVIEW',
  ClinicalProgramsCareNavigation = 'CLINICAL_PROGRAMS_CARE_NAVIGATION',
  ClinicalProgramsManager = 'CLINICAL_PROGRAMS_MANAGER',
  ClinicalSupportTeam = 'CLINICAL_SUPPORT_TEAM',
  Clubhouse = 'CLUBHOUSE',
  Colpo = 'COLPO',
  CommunityHealthWorker = 'COMMUNITY_HEALTH_WORKER',
  ContactAdmin = 'CONTACT_ADMIN',
  ContentAdmin = 'CONTENT_ADMIN',
  DceProvider = 'DCE_PROVIDER',
  Dermatologist = 'DERMATOLOGIST',
  DiabeticRetinopathyTeam = 'DIABETIC_RETINOPATHY_TEAM',
  DiscountTypeAdmin = 'DISCOUNT_TYPE_ADMIN',
  DuplicateReviewer = 'DUPLICATE_REVIEWER',
  EndometrialBiopsy = 'ENDOMETRIAL_BIOPSY',
  Engineer = 'ENGINEER',
  FamilyMedicine = 'FAMILY_MEDICINE',
  FieldCareCoordinatorsMphp = 'FIELD_CARE_COORDINATORS_MPHP',
  FrontDeskAdmin = 'FRONT_DESK_ADMIN',
  GoogleCepheidProvider = 'GOOGLE_CEPHEID_PROVIDER',
  GoogleNycWellness = 'GOOGLE_NYC_WELLNESS',
  GroupVisitCoordinator = 'GROUP_VISIT_COORDINATOR',
  GroupVisitFacilitator = 'GROUP_VISIT_FACILITATOR',
  Gyn = 'GYN',
  HealthCoach = 'HEALTH_COACH',
  HealthNavigator = 'HEALTH_NAVIGATOR',
  HighRiskCare = 'HIGH_RISK_CARE',
  HighRiskCareSchedulerMphp = 'HIGH_RISK_CARE_SCHEDULER_MPHP',
  HiResAnoscopy = 'HI_RES_ANOSCOPY',
  Hypnotherapist = 'HYPNOTHERAPIST',
  ImpactProvider = 'IMPACT_PROVIDER',
  IntegratedCardiologyAdmin = 'INTEGRATED_CARDIOLOGY_ADMIN',
  IntegrativeHealthLabs = 'INTEGRATIVE_HEALTH_LABS',
  Itstuff = 'ITSTUFF',
  IudInserter = 'IUD_INSERTER',
  IudRemover = 'IUD_REMOVER',
  JaneStreetAdmin = 'JANE_STREET_ADMIN',
  LactationConsultant = 'LACTATION_CONSULTANT',
  Legal = 'LEGAL',
  LicensedPracticalNurse = 'LICENSED_PRACTICAL_NURSE',
  Manager = 'MANAGER',
  Marketer = 'MARKETER',
  MassCancellation = 'MASS_CANCELLATION',
  MediaAndSocialResponseTeam = 'MEDIA_AND_SOCIAL_RESPONSE_TEAM',
  MedicalRecordsAdmin = 'MEDICAL_RECORDS_ADMIN',
  MedicationAdmin = 'MEDICATION_ADMIN',
  MedStudent = 'MED_STUDENT',
  MembershipAdvisor = 'MEMBERSHIP_ADVISOR',
  MemberIdentityAdmin = 'MEMBER_IDENTITY_ADMIN',
  MemberTechnicalSupport = 'MEMBER_TECHNICAL_SUPPORT',
  MenopauseProvider = 'MENOPAUSE_PROVIDER',
  MentalHealth = 'MENTAL_HEALTH',
  MindsetEnterprise = 'MINDSET_ENTERPRISE',
  MindBody = 'MIND_BODY',
  MssLssHybrid = 'MSS_LSS_HYBRID',
  Naturopath = 'NATUROPATH',
  NexplanonInserter = 'NEXPLANON_INSERTER',
  NexplanonRemover = 'NEXPLANON_REMOVER',
  Nutritionist = 'NUTRITIONIST',
  Ob = 'OB',
  OfficeRnNyc = 'OFFICE_RN_NYC',
  OmhEnrollmentMphp = 'OMH_ENROLLMENT_MPHP',
  OmhHealthNavigatorMphp = 'OMH_HEALTH_NAVIGATOR_MPHP',
  OmhRegisteredNurseMphp = 'OMH_REGISTERED_NURSE_MPHP',
  Osteopath = 'OSTEOPATH',
  OsteopathOnly = 'OSTEOPATH_ONLY',
  PanelManagementAdmin = 'PANEL_MANAGEMENT_ADMIN',
  Papper = 'PAPPER',
  ParetoAdmin = 'PARETO_ADMIN',
  Pcp = 'PCP',
  PeakmedCss = 'PEAKMED_CSS',
  Pediatrics = 'PEDIATRICS',
  PediatricsAdmin = 'PEDIATRICS_ADMIN',
  PedsUrgentCare = 'PEDS_URGENT_CARE',
  Pharmacist = 'PHARMACIST',
  Phlebotomist = 'PHLEBOTOMIST',
  PhysicalTherapy = 'PHYSICAL_THERAPY',
  PreconceptionCounseling = 'PRECONCEPTION_COUNSELING',
  PrenatalAdmin = 'PRENATAL_ADMIN',
  PrenatalUltrasound = 'PRENATAL_ULTRASOUND',
  ProblemTypeAdmin = 'PROBLEM_TYPE_ADMIN',
  Provider = 'PROVIDER',
  PsychiatricServices = 'PSYCHIATRIC_SERVICES',
  RadiologicTechnologist = 'RADIOLOGIC_TECHNOLOGIST',
  RaToolsEligibleProvider = 'RA_TOOLS_ELIGIBLE_PROVIDER',
  ResourceNavigationMphp = 'RESOURCE_NAVIGATION_MPHP',
  RespiratorProvider = 'RESPIRATOR_PROVIDER',
  Rn = 'RN',
  ScreeningHistoryBulkUploader = 'SCREENING_HISTORY_BULK_UPLOADER',
  SeniorBehavioralHealth = 'SENIOR_BEHAVIORAL_HEALTH',
  SeniorBehavioralHealthSpecialist = 'SENIOR_BEHAVIORAL_HEALTH_SPECIALIST',
  SeniorHealthInactivePatients = 'SENIOR_HEALTH_INACTIVE_PATIENTS',
  SeniorHealthNewProspectivePatients = 'SENIOR_HEALTH_NEW_PROSPECTIVE_PATIENTS',
  SeniorHealthPatientEligibility = 'SENIOR_HEALTH_PATIENT_ELIGIBILITY',
  SeniorHealthProvider = 'SENIOR_HEALTH_PROVIDER',
  SexualAndReproductiveHealthCss = 'SEXUAL_AND_REPRODUCTIVE_HEALTH_CSS',
  SocialWorker = 'SOCIAL_WORKER',
  SocialWorkersMphp = 'SOCIAL_WORKERS_MPHP',
  SpacexWellness = 'SPACEX_WELLNESS',
  SportsMedicine = 'SPORTS_MEDICINE',
  Teacher = 'TEACHER',
  TemplateEditor = 'TEMPLATE_EDITOR',
  Ucp = 'UCP',
  UcsfOb = 'UCSF_OB',
  UltrasoundTechnician = 'ULTRASOUND_TECHNICIAN',
  UnlicensedMedicalAssistant = 'UNLICENSED_MEDICAL_ASSISTANT',
  UrgentCareProvider = 'URGENT_CARE_PROVIDER',
  Vaccinator = 'VACCINATOR',
  VaccineDocumenter = 'VACCINE_DOCUMENTER',
  VirtualNpNpMphp = 'VIRTUAL_NP_NP_MPHP',
  VirtualPhysician = 'VIRTUAL_PHYSICIAN',
  VmtSupportQueueAccess = 'VMT_SUPPORT_QUEUE_ACCESS',
}

/** Attributes for submitting patient input from a routing step */
export interface RoutingStepInput {
  appointmentType?: InputMaybe<AppointmentTypeInput>;
  appointmentTypeId?: InputMaybe<Scalars['ID']>;
  appointmentTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  appointmentTypeLocked?: InputMaybe<Scalars['Boolean']>;
  attestedLocationId?: InputMaybe<Scalars['ID']>;
  careOptionId?: InputMaybe<Scalars['String']>;
  careOptionLocked?: InputMaybe<Scalars['Boolean']>;
  careOptionName?: InputMaybe<Scalars['String']>;
  /** The case type of the Treat Me Now. */
  caseType?: InputMaybe<Scalars['String']>;
  /** Optional UMED Clinical Concept ID */
  clinicalConceptId?: InputMaybe<Scalars['ID']>;
  /** The short name for the licensing body selected by the user. */
  licensingBodyShortName?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the office. */
  officeId?: InputMaybe<Scalars['ID']>;
  /** @deprecated Use careOptionName instead */
  optionName?: InputMaybe<Scalars['String']>;
  serviceAreaId?: InputMaybe<Scalars['ID']>;
  /** True if structured visit reason options were insufficient and user entered free text */
  structuredVisitReasonFallback?: InputMaybe<Scalars['Boolean']>;
  /** True if structured visit reason quick tap pill was selected */
  structuredVisitReasonQuickTapSelected?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated, do not use. To be removed. */
  surveyId?: InputMaybe<Scalars['ID']>;
  surveySystemName?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  topicBasedGuidanceEnabled?: InputMaybe<Scalars['Boolean']>;
  topicName?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of SavePatientPharmacy */
export interface SavePatientPharmacyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['ID']>;
  pharmacyId: Scalars['ID'];
  setAsPreferred?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated input type of SaveScribeConsent */
export interface SaveScribeConsentInput {
  appointmentId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  participantConsents?: InputMaybe<Array<ParticipantConsentInput>>;
  patientConsentStatus: Scalars['Boolean'];
}

/** Autogenerated input type of SelectServiceArea */
export interface SelectServiceAreaInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  serviceAreaId: Scalars['ID'];
}

export interface SelectedAnswerInput {
  /** UUIDs of the selected answers */
  answerNodeIds: Array<Scalars['ID']>;
  /** Free text input provided by the user */
  freeTextInput?: InputMaybe<Scalars['String']>;
  /** UUID to identify the question */
  questionNodeId: Scalars['ID'];
}

/** Autogenerated input type of SelfServiceLink */
export interface SelfServiceLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
}

/** Autogenerated input type of SendAppLink */
export interface SendAppLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
}

/** Autogenerated input type of SendForgotPasswordEmail */
export interface SendForgotPasswordEmailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** Set to true if the user is in the process of resetting their password for the purposes of enabling MFA. */
  mfaVerification?: InputMaybe<Scalars['Boolean']>;
  usePreferredEmail?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated input type of SendMembershipGroupInvite */
export interface SendMembershipGroupInviteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
}

export enum SendOrReceive {
  NotApplicable = 'NOT_APPLICABLE',
  Receive = 'RECEIVE',
  Send = 'SEND',
}

export enum Sentiment {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
}

export interface SentimentResponseInput {
  /** Unique ID assigned to each feedback question (client-defined) */
  questionId: Scalars['String'];
  /** The text of the question */
  questionText: Scalars['String'];
  /** Response from the user, either positive or negative */
  response: Sentiment;
}

export interface SideEffectFilterInput {
  recordedDateAfter?: InputMaybe<Scalars['DateTime']>;
  recordedDateBefore?: InputMaybe<Scalars['DateTime']>;
  recorderId?: InputMaybe<Scalars['ID']>;
  recorderIdType?: InputMaybe<Scalars['String']>;
}

/** Patient-reported side effect severity levels */
export enum SideEffectSeverityEnum {
  Midgrade = 'MIDGRADE',
  Mild = 'MILD',
  Severe = 'SEVERE',
}

export enum SideEffectSortEnum {
  /** Sort by created at ascending */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by created at descending */
  CreatedAtDesc = 'CREATED_AT_DESC',
  /** Sort by recorded date ascending */
  DateAsc = 'DATE_ASC',
  /** Sort by recorded date descending */
  DateDesc = 'DATE_DESC',
}

/** Autogenerated input type of SignLegalDocument */
export interface SignLegalDocumentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
}

export interface SingleValuedMeasurementInput {
  collectedAt: Scalars['DateTime'];
  type: MeasurementName;
  value: Scalars['Float'];
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum Source {
  System = 'SYSTEM',
  User = 'USER',
}

/** Source of health record data */
export enum SourceEnum {
  /** Data from Aspen */
  Aspen = 'ASPEN',
  /** Data from OneLife's internal systems */
  Onelife = 'ONELIFE',
}

/** Autogenerated input type of StartManualHieQuery */
export interface StartManualHieQueryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
}

/** Autogenerated input type of StoreAccessToken */
export interface StoreAccessTokenInput {
  accessToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

export enum SurveyAnswerCheckboxCustomBehavior {
  DefaultSelected = 'default_selected',
  SelectAll = 'select_all',
  SelectAllExcluded = 'select_all_excluded',
  SelectNone = 'select_none',
}

export enum SurveyAnswerDatePickerCustomBehavior {
  Future = 'future',
  MonthYearOnly = 'month_year_only',
  Past = 'past',
}

export enum SurveyAnswerKind {
  BinaryRadio = 'binary_radio',
  Boolean = 'boolean',
  Checkbox = 'checkbox',
  DatePicker = 'date_picker',
  DateRange = 'date_range',
  DateString = 'date_string',
  FreeText = 'free_text',
  FsaHsaGridInput = 'fsa_hsa_grid_input',
  HorizontalRadio = 'horizontal_radio',
  MultiSelect = 'multi_select',
  Radio = 'radio',
  Scale = 'scale',
  Select = 'select',
}

/** Autogenerated input type of SwitchToRemoteAppointment */
export interface SwitchToRemoteAppointmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Self-pay estimate range for the appointment */
  selfPayEstimate?: InputMaybe<Scalars['String']>;
  sendSms: Scalars['Boolean'];
  smsNumber?: InputMaybe<Scalars['String']>;
}

export interface SystemMessagePayloadInput {
  content: Scalars['String'];
  requiresSystemMessageInput: Scalars['Boolean'];
  type: Scalars['String'];
  urgency: SystemMessageUrgency;
}

export enum SystemMessageUrgency {
  Emergency = 'emergency',
  NotUrgent = 'not_urgent',
  Urgent = 'urgent',
}

export enum TimelinePostSort {
  /** Sorts posts by sent date. If a post has comments, the most recent sent date is used for sorting. If a post does not have comments, the post's sent date is used for sorting. */
  RecentActivity = 'RecentActivity',
}

export interface ToolAttributeInput {
  /** The name of the attribute */
  attributeName?: InputMaybe<Scalars['String']>;
  /** Describes the attributeValue's intended Type */
  attributeType?: InputMaybe<Attribute>;
  /** The value of this attribute, encoded as a String */
  attributeValue?: InputMaybe<Scalars['String']>;
}

export interface ToolInvocationInput {
  /** A list of arguments the Toucan has chosen to provide to the tool */
  arguments?: InputMaybe<Array<ToolAttributeInput>>;
  /** The name of the tool which Toucan is telling its client to use */
  toolName?: InputMaybe<Scalars['String']>;
}

export interface ToolUsePayloadInput {
  /** Tool use requests from Toucan to the client */
  toolUseRequests: ToolUseRequestsPayloadInput;
  /** Tool use responses from client back to Toucan */
  toolUseResponse: ToolUseResponsePayloadInput;
}

export interface ToolUseRequestsPayloadInput {
  /** List of tool invocations requested by Toucan */
  toolInvocations: Array<ToolInvocationInput>;
}

export interface ToolUseResponseErrorInput {
  /** Details why the tool use failed */
  errorReason?: InputMaybe<Scalars['String']>;
  /** If Toucan can try invoking the tool again */
  retryAvailable?: InputMaybe<Scalars['Boolean']>;
}

export interface ToolUseResponseInput {
  /** If the tool use request was unsuccessful, provides error details */
  error: ToolUseResponseErrorInput;
  /** The value which represents the result of invoking the tool */
  responseEntities?: InputMaybe<Array<ResponseEntityInput>>;
  /** The name of the tool which was invoked */
  toolName?: InputMaybe<Scalars['String']>;
}

export interface ToolUseResponsePayloadInput {
  /** List of client-provided response(s) to Toucan's Tool invocation(s) */
  toolUseResponses: Array<ToolUseResponseInput>;
}

/** Types of top dividers that can be displayed above sections */
export enum TopDivider {
  /** No divider displayed */
  None = 'NONE',
  /** Thin horizontal line divider */
  Thin = 'THIN',
}

export interface ToucanAttachmentInput {
  /** S3 bucket name for the attachment */
  s3Bucket: Scalars['String'];
  /** S3 object key for the attachment */
  s3ObjectKey: Scalars['String'];
}

/** Autogenerated input type of ToucanContinueConversation */
export interface ToucanContinueConversationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the current conversation (UUID) */
  conversationId: Scalars['String'];
  /** Dialog turn with the payload populated with the user's response */
  dialogTurn: ToucanDialogTurnInput;
}

export interface ToucanDialogTurnInput {
  /** ID of the current dialog turn (UUID) */
  dialogTurnId: Scalars['String'];
  /** Not used since the user won't be the source of generated responses */
  generatedResponsePayload?: InputMaybe<GeneratedResponsePayloadInput>;
  /** If true, indicates that IHS considers this the end of the conversation. */
  isTerminal: Scalars['Boolean'];
  /** Multiple choice payload populated with the user's answer(s) */
  multipleChoicePayload?: InputMaybe<MultipleChoicePayloadInput>;
  /** Set to "USER" to indicate this dialog turn is a response from the user. */
  source: Source;
  /** Not used since the user won't be the source of system messages */
  systemMessagePayload?: InputMaybe<SystemMessagePayloadInput>;
  /** This payload allows Toucan to request tool use and receive tool use results. */
  toolUsePayload?: InputMaybe<ToolUsePayloadInput>;
  /** Free text payload populated with response text from the user's */
  userFreetextPayload?: InputMaybe<UserFreeTextPayloadInput>;
}

export interface ToucanFeedbackResponseInput {
  /** Zero or more responses for free-text feedback questions */
  freetextResponse?: InputMaybe<Array<FreetextResponseInput>>;
  /** Zero or more responses for multiple choice feedback questions */
  multipleChoiceResponse?: InputMaybe<Array<MultipleChoiceResponseInput>>;
  /** Zero or more responses for sentiment feedback questions */
  sentimentResponse?: InputMaybe<Array<SentimentResponseInput>>;
}

/** Autogenerated input type of ToucanGenerate */
export interface ToucanGenerateInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the current conversation (UUID) */
  conversationId: Scalars['String'];
  /** ID of the dialog turn whose content to be generated (UUID) */
  dialogTurnId: Scalars['String'];
  /** A string indicating where the patient came from */
  source?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of ToucanNewConversation */
export interface ToucanNewConversationInput {
  /** Array of attachments with S3 object keys and bucket names */
  attachments?: InputMaybe<Array<ToucanAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The initial prompt to start a new conversation */
  content: Scalars['String'];
}

/** Autogenerated input type of ToucanRegisterFeedback */
export interface ToucanRegisterFeedbackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the current conversation (UUID) */
  conversationId: Scalars['String'];
  /** ID of the dialog turn this feedback applies to */
  dialogTurnId: Scalars['String'];
  /** Feedback responses from the user */
  feedbackResponse: ToucanFeedbackResponseInput;
}

/** Input type for updating treatment plan notification preferences */
export interface TreatmentPlanNotificationPreferencesInput {
  adherenceReminders: Scalars['Boolean'];
}

/** Treatment plan status values */
export enum TreatmentPlanStatusEnum {
  Candidate = 'CANDIDATE',
  Complete = 'COMPLETE',
  Enrolled = 'ENROLLED',
  Incomplete = 'INCOMPLETE',
}

export interface UdiCarrierAttributes {
  deviceIdentifier?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of UnlinkFamilyAccountMember */
export interface UnlinkFamilyAccountMemberInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the family account member to unlink */
  familyAccountMemberId: Scalars['ID'];
}

/** Autogenerated input type of UpdateBookingSessionReasonForVisit */
export interface UpdateBookingSessionReasonForVisitInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  reasonForVisit: Scalars['String'];
}

/** Autogenerated input type of UpdateDefaultCopayStripeIdForPatient */
export interface UpdateDefaultCopayStripeIdForPatientInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
}

/** Autogenerated input type of UpdateHieOptIn */
export interface UpdateHieOptInInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The version of the Health Information Exchange Legal Text that was displayed to the user. */
  healthInformationExchangeLegalTextVersion: Scalars['Int'];
  healthInformationExchangeOptIn: Scalars['Boolean'];
}

/** Autogenerated input type of UpdateMfaEmailSettings */
export interface UpdateMfaEmailSettingsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The email to use for MFA */
  email: Scalars['String'];
}

/** Autogenerated input type of UpdateMfaPhoneSettings */
export interface UpdateMfaPhoneSettingsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The phone number to use for MFA */
  phoneNumber: Scalars['String'];
  /** The preferred delivery method to use for MFA. Valid options are 'sms' or 'voice' */
  preferredDeliveryMethod: MfaFactor;
}

/** Autogenerated input type of UpdatePatient */
export interface UpdatePatientInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  profileInfo: ProfileInfo;
}

/** Autogenerated input type of UpdatePatientOnboardingTask */
export interface UpdatePatientOnboardingTaskInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: OnboardingTaskName;
  status: OnboardingTaskStatus;
}

/** Autogenerated input type of UpdatePatientPcp */
export interface UpdatePatientPcpInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  officeId: Scalars['ID'];
  providerId: Scalars['ID'];
}

/** Autogenerated input type of UpdatePatientPreferences */
export interface UpdatePatientPreferencesInput {
  acceptsClinicalEmails?: InputMaybe<Scalars['Boolean']>;
  acceptsPatientTaskEmails?: InputMaybe<Scalars['Boolean']>;
  acceptsPatientTaskPush?: InputMaybe<Scalars['Boolean']>;
  aiAssistantEnabled?: InputMaybe<Scalars['Boolean']>;
  avsHideWeight?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  connectedDevicesOptIn?: InputMaybe<Scalars['Boolean']>;
  consentsToScribeRecording?: InputMaybe<Scalars['Boolean']>;
  fullTextNotifications?: InputMaybe<Scalars['Boolean']>;
  needsLanguageInterpreter?: InputMaybe<Scalars['Boolean']>;
}

/** Autogenerated input type of UpdatePatientTask */
export interface UpdatePatientTaskInput {
  appointmentId?: InputMaybe<Scalars['ID']>;
  cityName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedback?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['String']>;
  providerOrFacilityName?: InputMaybe<Scalars['String']>;
  state: PatientTaskState;
  year?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of UpdatePendingDirectSignupAccount */
export interface UpdatePendingDirectSignupAccountInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
}

/** Autogenerated input type of UpdatePreferredCopayStripeIdForPatient */
export interface UpdatePreferredCopayStripeIdForPatientInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
}

/** Autogenerated input type of UpdateRegistrationWaitlistEnrollment */
export interface UpdateRegistrationWaitlistEnrollmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  serviceAreaCode: Scalars['String'];
}

/** Autogenerated input type of UpdateRoutingMetadata */
export interface UpdateRoutingMetadataInput {
  channelSelected?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['ID'];
}

/** Autogenerated input type of UpdateStripePaymentMethodForPatient */
export interface UpdateStripePaymentMethodForPatientInput {
  billingName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['Int']>;
  expYear?: InputMaybe<Scalars['Int']>;
  nickname?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
}

/** Autogenerated input type of UpdateToLimitedAccessMembership */
export interface UpdateToLimitedAccessMembershipInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
}

/** Autogenerated input type of UpdateTreatmentPlanNotificationPreferences */
export interface UpdateTreatmentPlanNotificationPreferencesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  preferences: TreatmentPlanNotificationPreferencesInput;
  treatmentPlanId: Scalars['ID'];
}

/** Autogenerated input type of UpdateUserNotification */
export interface UpdateUserNotificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
}

export interface UserFreeTextPayloadInput {
  /** Array of attachments with S3 object keys and bucket names */
  attachments?: InputMaybe<Array<ToucanAttachmentInput>>;
  /** Prompt text from the user to be sent to IHS-Service */
  content?: InputMaybe<Scalars['String']>;
  /** Set to true as returned by toucanNewConversation or toucanContinueConversation */
  requiresUserFreeTextInput: Scalars['Boolean'];
  /** must be "userFreeText" */
  type: Scalars['String'];
}

/** Autogenerated input type of ValidateClaimCode */
export interface ValidateClaimCodeInput {
  claimCode: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  purchaseRef?: InputMaybe<Scalars['String']>;
}

/** Verification status values for conditions and allergies */
export enum VerificationStatusEnum {
  /** The condition/allergy is confirmed */
  Confirmed = 'CONFIRMED',
  /** The condition/allergy is differential */
  Differential = 'DIFFERENTIAL',
  /** The condition/allergy was entered in error */
  EnteredInError = 'ENTERED_IN_ERROR',
  /** The condition/allergy is provisional */
  Provisional = 'PROVISIONAL',
  /** The condition/allergy has been refuted */
  Refuted = 'REFUTED',
  /** The condition/allergy is unconfirmed */
  Unconfirmed = 'UNCONFIRMED',
}

/** Autogenerated input type of VerifyOtpCode */
export interface VerifyOtpCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 6-digit OTP code */
  otpCode: Scalars['String'];
  /** Verification token from identity verification */
  verificationToken: Scalars['String'];
}

/** Autogenerated input type of VerifyPatientPassword */
export interface VerifyPatientPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The password to verify that the user is authenticated */
  currentPassword: Scalars['String'];
}

/** Autogenerated input type of VerifyYourIdentity */
export interface VerifyYourIdentityInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Patient's date of birth (YYYY-MM-DD) */
  dateOfBirth: Scalars['String'];
  /** Patient's preferred email address */
  email: Scalars['String'];
  /** Patient's phone number */
  phoneNumber: Scalars['String'];
}

/** Parameters for searching for visit reasons */
export interface VisitReasonSearchParameters {
  /** Search query */
  query: Scalars['String'];
}

/** Autogenerated input type of WellnessBenefitsDeleteLabRecord */
export interface WellnessBenefitsDeleteLabRecordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: DeleteLabRecordInput;
}

/** Autogenerated input type of WellnessBenefitsEnrollUser */
export interface WellnessBenefitsEnrollUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: EnrollUserInput;
}
